const React = require('react');
const { default: Switch } = require('@mui/material/Switch');
const { default: Styled } = require('styled-components');

const internals = {};

module.exports = function FormSwitchField(props) {

    const {
        field = {},
        label = field.definition?.label || field.label,
        onBlur,
        onChange,
        onFocus,
        setValue,
        switchProps = {},
        value = false
    } = props;
    const switchId = switchProps.id;
    const switchInputProps = {
        'aria-label': label,
        ...(switchProps.inputProps || {})
    };

    if (switchId && !switchInputProps.id) {
        switchInputProps.id = switchId;
    }

    return <internals.SwitchFieldRoot>
        <internals.SwitchFieldLabel>
            {label}
        </internals.SwitchFieldLabel>
        <internals.SwitchFieldControl>
            <internals.SwitchFieldChoiceLabel>
                {field.offLabel || 'No/Skip'}
            </internals.SwitchFieldChoiceLabel>
            <Switch
                checked={!!value}
                color='primary'
                inputProps={switchInputProps}
                onBlur={onBlur}
                onChange={(event) => {

                    const nextValue = event.target.checked;

                    if (typeof setValue === 'function') {
                        setValue(nextValue, undefined, event);
                    }

                    if (typeof onChange === 'function') {
                        onChange(nextValue, event);
                    }
                }}
                onFocus={onFocus}
                {...switchProps}
            />
            <internals.SwitchFieldChoiceLabel>
                {field.onLabel || 'Yes'}
            </internals.SwitchFieldChoiceLabel>
        </internals.SwitchFieldControl>
    </internals.SwitchFieldRoot>;
};

internals.SwitchFieldRoot = Styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 38px;
    gap: ${({ theme }) => theme.spacing(2)};
`;

internals.SwitchFieldLabel = Styled.div`
    flex: 1 1 auto;
    min-width: 0;
    font-size: 16px;
    line-height: 20px;
    color: ${({ theme }) => theme.palette.text.primary};
`;

internals.SwitchFieldControl = Styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${({ theme }) => theme.spacing(.5)};
    white-space: nowrap;
`;

internals.SwitchFieldChoiceLabel = Styled.span`
    font-size: 12px;
    line-height: 16px;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

module.exports.internals = internals;
